import React, { useState, useEffect, useContext, useRef, Children } from 'react';

import Arrow from 'assets/svg/small-arrow.svg';

import s from './NavSection.scss';
import { Link } from 'components/link/Link';
import { UIContext } from 'context/ui';
import gsap from 'gsap';

interface IProps {
  children: React.ReactNode;
  heading: React.ReactNode;
  link?: string;
}

export const NavSection = ({ heading, children, link }: IProps) => {

  const { isDesktop, navOpen } = useContext<any>(UIContext);
  const listRef = useRef<HTMLUListElement>(null);
  const [open, toggle] = useState(false);

  const hasChildren = Children.count(children) > 0;
  
  const t = gsap.timeline();

  useEffect(() => {
    if (!listRef.current || !navOpen) {
      return;
    }

    if (isDesktop) {
      gsap.killTweensOf(listRef.current);
    } else {
      if (open) {
        t.to(listRef.current, { height: 'auto', duration: 0.4, ease: 'power3.inOut' });
      } 
      else {
        t.to(listRef.current, { height: 0, duration: 0.2 });
      }
    }

  }, [isDesktop, open]);

  const content = (
    <>
      {hasChildren && <Arrow className={s.navSection__arrow} />}
      {heading}
    </>
  );

  // conditional for mobile / desktop
  const renderHeading = (isDesktop || !isDesktop && !hasChildren) ? (
    <h2 className={s.navSection__heading}>
      {link ? <Link to={link}>{content}</Link> : content}
    </h2>
  ) : 
  (<button className={s.navSection__heading} onClick={() => toggle(!open)}>{content}</button>);

  return (
    <li className={s('navSection', { hasChildren, open })}>
      {renderHeading}

      <ul ref={listRef} className={s.navSection__list}>
        {Children.map(children, (child, i) => (
          <li className={s.navSection__li} key={i}>{child}</li>
        ))}
      </ul>
    </li>
  );
};
